import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap, tap } from 'rxjs';
import { AuthService } from 'src/app/features/auth/authentication/services/auth.service';
import { LocalStorageService } from 'src/app/shared/localstorage.service';
import { normalizePermissionNames } from './permissions.catalog';
import {
  loadPermissionsFromLogin,
  refreshPermissions,
  refreshPermissionsFailure,
  refreshPermissionsSuccess,
} from './permissions.actions';

@Injectable()
export class PermissionsEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly authService: AuthService
  ) {}

  refreshPermissions$ = createEffect(() =>
    this.actions$.pipe(
      ofType(refreshPermissions),
      switchMap(() =>
        this.authService.getMyPermissions().pipe(
          map((response) =>
            refreshPermissionsSuccess({ permissions: response.data ?? [] })
          ),
          catchError((err) => {
            console.error(
              '[PermissionsEffects] Failed to refresh permissions',
              err
            );
            return [refreshPermissionsFailure()];
          })
        )
      )
    )
  );

  persistPermissions$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(loadPermissionsFromLogin, refreshPermissionsSuccess),
        tap(({ permissions }) => {
          const currentUser = LocalStorageService.get('currentUser');
          if (!currentUser?.access_token || !currentUser?.user) {
            console.warn(
              '[PermissionsEffects] Skipping permission persistence: ' +
                'no authenticated currentUser in localStorage'
            );
            return;
          }

          LocalStorageService.put('currentUser', {
            ...currentUser,
            user: {
              ...currentUser.user,
              permissions: normalizePermissionNames(permissions),
            },
          });
        })
      ),
    { dispatch: false }
  );
}
